import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import type { OnboardingVideoProps } from './onboarding-wizard.interface'

/**
 * Responsive YouTube video embed with 16:9 aspect ratio.
 */
export const OnboardingVideo: React.FC<OnboardingVideoProps> = ({
  videoId,
  className,
}): ReactNode => (
  <div className={cn('onboarding-video aspect-video w-full overflow-hidden rounded-lg', className)}>
    <iframe
      src={`https://www.youtube.com/embed/${videoId}?rel=0`}
      title="Getting started with SAAGA"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      className="h-full w-full border-0"
    />
  </div>
)
